import { Component, Vue } from 'vue-property-decorator';
import ModalEventBus, { IModal } from 'Events/ModalEventBus';


//TODO: make it easier to be a DEVELOPER!
@Component({
    
})
export default class ModalMixin extends Vue 
{

    async created(){
        
    }


    // public showModal(modalType:string, payload: ICustomModal) : void
    // {
    //     ModalEventBus.$emit('custom-component-wrapper-add', {type: 'custom-modal-component' });
    //     // this.selectedDeleteOption = this.dataDeliveryAddresses.find(x => x.id === option.id);
    // }
}
